import { CryptoWalletProps } from './CryptoWallet.interface';
import { IcCheck28, IcCopy20 } from '$assets';
import './CryptoWallet.sass';
import { useMemo, useState } from 'react';

export const CryptoWallet = ({ address, href, cut = true }: CryptoWalletProps) => {
  const [clipboardSuccess, setClipboardSuccess] = useState(false);

  if (!address) {
    return null;
  }

  const formatAddress = useMemo(() => {
    return address.length <= 10 || !cut
      ? address
      : `${address.slice(0, 5)}...${address.slice(address.length - 5, address.length)}`;
  }, [address]);

  return (
    <div
      className="CryptoWallet"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setClipboardSuccess(true);
        navigator.clipboard.writeText(address);
        setTimeout(() => setClipboardSuccess(false), 2000);
      }}
    >
      <div className="CryptoWallet__copy">
        {clipboardSuccess ? <IcCheck28 /> : <IcCopy20 />}
      </div>
      {href ? (
        <a target="_blank" href={href} rel="noreferrer">
          {formatAddress}
        </a>
      ) : (
        formatAddress
      )}
    </div>
  );
};
